import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  APPLICATION_FEATURE_KEY,
  ApplicationState,
} from './application.reducer';
import { ScreenSize } from '@lyceo/shared/util-models';
import { LoadingState } from '@lyceo/shared/util-loading';

export const selectApplicationState = createFeatureSelector<ApplicationState>(
  APPLICATION_FEATURE_KEY,
);

export const selectScreenSize = createSelector(
  selectApplicationState,
  (state: ApplicationState) => state.screenSize,
);

export const selectIsScreenSizeXs = createSelector(
  selectScreenSize,
  (screenSize: ScreenSize | undefined) => screenSize === ScreenSize.XS,
);

export const selectIsScreenSizeSm = createSelector(
  selectScreenSize,
  (screenSize: ScreenSize | undefined) => screenSize === ScreenSize.SM,
);

export const selectIsScreenSizeMd = createSelector(
  selectScreenSize,
  (screenSize: ScreenSize | undefined) => screenSize === ScreenSize.MD,
);

export const selectIsScreenSizeLg = createSelector(
  selectScreenSize,
  (screenSize: ScreenSize | undefined) => screenSize === ScreenSize.LG,
);

export const selectIsScreenSizeXl = createSelector(
  selectScreenSize,
  (screenSize: ScreenSize | undefined) => screenSize === ScreenSize.XL,
);

export const selectIsAnyOfScreenSizes = (screenSizes: ScreenSize[]) =>
  createSelector(
    selectScreenSize,
    (screenSize: ScreenSize | undefined) =>
      screenSize !== undefined && screenSizes.includes(screenSize),
  );

export const selectGuardsState = createSelector(
  selectApplicationState,
  (state: ApplicationState) => state.guardsState,
);

export const selectGuardsLoaded = createSelector(
  selectGuardsState,
  (callState) => callState === LoadingState.LOADED,
);
